const AdminModule = () => import("./AdminModule.vue");
import dashboard from '../dashboard/dashboard-router';
import slideBox from '../my-slide-box/slide-box-router';
import educationalMaterialRoutes from '../educational-material/educational-material-router';
import myPresentationRoutes from '../my-presentation/my-presentation-router';
import administration from '../administration/administration-router';
import slideLibrary from '../slide-library/slide-library-router';
import profile from '../profile/profile-router';

export default {
  path: "/",
  component: AdminModule,
  children: [
    dashboard,
    slideBox,
    administration,
    educationalMaterialRoutes,
    myPresentationRoutes,
    slideLibrary,
    profile
  ],
};
